const hostData = {
  name: "Gary Stalley",
  bio: "Welcome to Stalley Beach House! We've been hosting guests at this beautiful beachfront property in Costa Rica for years, and we take pride in making every stay unforgettable. Whether you're here for the surf, the sunsets, or the adventure, we're here to help you make the most of your trip.",
  yearsHosting: 20,
  responseRate: "100%",
  responseTime: "within a day",
  superhost: true,
  languages: ["English", "Spanish"],
};

export default hostData;
